module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/footer/nflPlayers-e116c72e750bfe9456d0d68ad671d1f9.svg";